import Glide from '@glidejs/glide'

var About = {
    testimonials: function () {
      var count = document.querySelectorAll(".clients-section .testimonial-link").length;
  
      if (count >= 1) {
        var slidesToShow = 2;
        var slidesToScroll = 2;
  
        if (window.innerWidth <= 769) {
          slidesToShow = 1;
          slidesToScroll = 1;
        }

        var sliderContainer = document.querySelector('.glide');
        if (sliderContainer) {
          var slider = new Glide(sliderContainer, {
            autoplay: 10000,
            arrows: false,
            speed: 0,
            dots: false,
            infinite: true,
            perView: slidesToShow, 
            slidesToScroll: slidesToScroll,
            cssEase: 'linear'
          }).mount();
        }
  
        function setActiveLinks(currentSlide) {
          var links = document.querySelectorAll('.testimonial-link');
          links.forEach((link, index) => {
            link.classList.remove('active');
            if (index === currentSlide || (index === currentSlide + 1 && window.innerWidth >= 770)) {
              link.classList.add('active');
            }
          });
        }
  
        function goToSlide(index) {
          setActiveLinks(index);
          slider.go('=' + index);
        }
  
        function onResize() {
          if (window.innerWidth <= 769) {
            slidesToShow = 1;
            slidesToScroll = 1;
          } else {
            slidesToShow = 2;
            slidesToScroll = 2;
          }
          slider.update({'perView': slidesToShow});
          slider.update({'slidesToScroll': slidesToScroll});
        }
  
        slider.on('run', function () {
          setActiveLinks(slider.index);
        });
  
        document.querySelectorAll('.testimonial-link').forEach((link, index) => {
          link.addEventListener('click', function () {
            goToSlide(index);
          });
        });
  
        window.addEventListener('resize', onResize);
      }
    },
    teamFilters: function () {
      var filters = document.querySelector('.team-section--filtered .team-filters');
      if (!filters) return;

      var roleButtons = filters.querySelectorAll('.team-filter:not(.clear-all)');
      var clearAll = filters.querySelector('.clear-all');
      var items = document.querySelectorAll('.team-section--filtered .team-grid .item');

      function clearRoleActive() {
        roleButtons.forEach(function (button) {
          button.classList.remove('active');
        });
      }

      function filterByRole(role) {
        items.forEach(function (item) {
          if (role === 'all') {
            item.hidden = false;
            return;
          }
          var roles = (item.getAttribute('data-roles') || '').split(/\s+/);
          item.hidden = roles.indexOf(role) === -1;
        });
      }

      roleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          clearRoleActive();
          button.classList.add('active');
          if (clearAll) clearAll.classList.add('active');
          filterByRole(button.getAttribute('data-role'));
        });
      });

      if (clearAll) {
        clearAll.addEventListener('click', function () {
          clearRoleActive();
          clearAll.classList.remove('active');
          filterByRole('all');
        });
      }
    },
    init: function () {
      setTimeout(this.vimeo, 1000);
      this.testimonials();
      this.teamFilters();
    },
};


if (document.querySelector(".about-us-page")) {
  About.init();
  // Get all videos on page in content
  var videos = document.querySelectorAll('video');
  if (videos) {
    Array.from(videos).forEach((video) => {
      const videoUrl = video.getAttribute('src');
      const firstSection = videoUrl.slice(55);
      const secondSection = firstSection.split('/')[0];
      // Add poster attribute to video player
      video.setAttribute('poster', 'https://vumbnail.com/' + secondSection + '.jpg');
    });
  }
}